import React, { useRef } from "react"
import Slider from "react-slick"

const TourCarousel = ({blok}) => {
  // console.log(blok.carousel)

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }
  
  const settings = {
    autoplay: false,
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: Math.min(4, blok.carousel?.length || 4),
    slidesToScroll: Math.min(4, blok.carousel?.length || 4),
    
    responsive: [
      { breakpoint: 1280, settings: { 
        slidesToShow: Math.min(3, blok.carousel?.length || 3), 
        slidesToScroll: Math.min(3, blok.carousel?.length || 3) 
      }},
      { breakpoint: 1024, settings: { 
        slidesToShow: Math.min(2, blok.carousel?.length || 2), 
        slidesToScroll: Math.min(2, blok.carousel?.length || 2) 
      }},
      { breakpoint: 640, settings: { slidesToShow: 1, slidesToScroll: 1 }},
    ]
  }

  const TourCarouselItem = ({img}) => (
    <div className="px-1 relative">
      <img 
        className={`h-[350px] md:h-[400px] object-cover items-center w-full`} 
        loading="lazy" 
        src={img?.filename} 
        alt={img?.alt} 
      />

      <div className="absolute top-0 w-full font-serif text-xs p-4 text-white bg-gradient-to-b from-black/50 to-transparent h-16">
        {img?.name || img?.title}
      </div>

      {img?.copyright && (
        <span className="absolute bottom-0 text-xs text-white p-1 bg-black bg-opacity-15">
          &copy; {img?.copyright}
        </span>
      )}

    </div>
  )

  return (
    <section className="my-2 pt-8 pb-6"
      style={{backgroundColor: `${blok.carouselBgColor?.color}`}}>

      <div className="max-w-screen-2xl p-0 md:p-2 mx-auto overflow-x-hidden">
        <div className="slider-container">
          <Slider ref={sliderRef} {...settings} >{blok.carousel?.map((img, index) => (<TourCarouselItem img={img} key={index}/> ))}</Slider>
          { blok.carousel?.length > 4 &&
          <div className="flex justify-center gap-2 p-4">
            <button className="button slick-arrow-mobile block" onClick={previous}>
              <img className="w-12 rotate-180" src="/icons/carousel-arrow-right.svg" alt="Prev button"/>
            </button>
            <button className="button slick-arrow-mobile block" onClick={next}>
              <img className="w-12" src="/icons/carousel-arrow-right.svg" alt="Next button"/>
            </button>
          </div>
          }
        </div>
      </div>

    </section>
  )
}
  
export default TourCarousel
